import script from "./TimetableSearchBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSearchBanner.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSearchBanner.vue?vue&type=style&index=0&id=a25b9790&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a25b9790"]])

export default __exports__